export default __webpack_public_path__ + "static/media/crunchers-whiteboarding2.56bf42dd.png";